import * as React from 'react';
import { useState } from 'react';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { createBrowserHistory } from 'history';
import { useHistory } from 'react-router-dom'
import 'react-notifications-component/dist/theme.css';
import { Col, Row } from "reactstrap";
import { languageAction } from '../../actions/languageAction';
import { DABButton, DABTextBox, DABBackToList, LoadingSpinnerModal } from '../../components/dab';
import { showAlert } from "../common/functions";

interface ILanguageProps {
	dispatch: Dispatch<any>;
	callback: any;
	languageCode: string;
	languageData: any;
}

const LanguageDetail: React.SFC<ILanguageProps> = ({
	dispatch, languageData, callback, languageCode }) => {
	var languagesInput = {
		languageCode: "",
		name: "",
	}

	const history = useHistory()

	const [formSubmit, setformSubmit] = useState(false);
	const [isPreviewPage, setIsPreviewPage] = useState(false);
	const [input, setInput] = useState(languagesInput);
	const [showModal, setShowModal] = useState(false);
	const [isDetailLoaded, setIsDetailLoaded] = useState(false);
	const [isErrorOnPage, setIsErrorOnPage] = useState(false);
	const [isDirty, setIsDirty] = useState<boolean>(false)

	const handleInputChange = (event) => {
		let name = event.target.name;
		let value = event.target.value;
		if (name === '') { return; }
		setInput({
			...input,
			[name]: value
		});
		setIsDirty(true)
	};

	const handleNextClick = (event) => {
		event.preventDefault();
		if (!isPreviewPage) {
			setIsPreviewPage(true);
			callback("Review Create New");
		}
		else if (isPreviewPage) {
			handleSubmit(event);
		}
	}

	const handleBackClick = (event) => {
		event.preventDefault();
		if (isPreviewPage) {
			setIsPreviewPage(false);
		}
		else if (!isPreviewPage) {
			history.goBack();
		}
	}

	const handleLoadShowModal = (value: boolean) => {
		setShowModal(value);
	};

	const handleSubmit = (event) => {
		event.preventDefault();
		setformSubmit(true);
		setShowModal(true);
		if (isPreviewPage) {
			dispatch(languageAction.languageSave({ language: input }));
		}
		else {
			dispatch(languageAction.languageUpdate({ language: input }));
		}

		setIsErrorOnPage(false);
	};

	React.useEffect(() => {
		if (languageCode !== '') {
			dispatch(languageAction.languageGetDetail(languageCode));
			setShowModal(true);
		}
	}, []);

	if (languageData) {
		if (languageData.isError && !isErrorOnPage) {	
			languageData.isError = false;
			setIsErrorOnPage(true);
			if (languageData.status === 'Unauthorized') {
				history.push({ pathname: '/401', state:'language'});
			} else {
				showAlert(languageData.status, true);
			}
			setShowModal(false);
		}

		if (formSubmit && languageData.isSuccess && !languageData.isError) {			
			window.localStorage.setItem('alertMessage', languageData.status);
			window.location.href = '/language';			
		}

		if (languageData.isSuccess) {
			if (!isDetailLoaded && languageData.item) {
				setInput(languageData.item);
				callback(languageData.item.name);
				setIsDetailLoaded(true);
			}
			if (showModal) {
				setShowModal(false);
			}
		}
	}

	React.useEffect(() => {		
		const eventHandler = (event: BeforeUnloadEvent) => {
			var sessionExpiry = window.localStorage.getItem('SESSIONEXPIRY');
			const inSession = Date.now() < Number(sessionExpiry)
			if (!formSubmit && inSession) {
				event.preventDefault();
				event.returnValue = "";
			}
		};
		if (isDirty) { window.addEventListener("beforeunload", eventHandler) }
		return () => { window.removeEventListener("beforeunload", eventHandler) };
	}, [isDirty && !formSubmit])


	return (
		<div className="language-detail">
			{showModal && (<LoadingSpinnerModal isShowModal={showModal} modalChange={handleLoadShowModal} />)}
			<div className='card-box'>
				{!isDetailLoaded && !isPreviewPage && (
					<form name="createform" onSubmit={handleNextClick}>
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="languageCode" className={["col-sm-2 col-form-label"].join(" ")} data-testid="lblLangCode">Code</label>
							<div data-testid="languageCodeContainer" className={["col-sm-5"].join(" ")}>
								<DABTextBox id="languageCode" maxLength={2} isRequired={true} onChange={(event) => { handleInputChange(event) }} value={input.languageCode} />
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="name" className={["col-sm-2 col-form-label"].join(" ")} data-testid="lbllang">Language</label>
							<div data-testid="nameContainer" className={["col-sm-5"].join(" ")}>
								<DABTextBox id="name" maxLength={50} isRequired={true} onChange={(event) => { handleInputChange(event) }} value={input.name} />
							</div>
						</div>
						<Row className="lang-create-buttons">
							<Col lg="2">
								<DABButton id="cancel" value="CANCEL" className="" onClick={(e) => { handleBackClick(e); }}></DABButton>
							</Col>
							<Col lg="2" data-testid="nextButtonContainer">
								<DABButton id="submit" className="btn-submit-frm" value="NEXT"></DABButton>
							</Col>
						</Row>
					</form>)}
				{isPreviewPage && !isDetailLoaded && (
					<div style={{ display: `${isPreviewPage ? '' : 'none'}` }}>
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="languageCode" className={["col-sm-2 col-form-label"].join(" ")} >Code</label>
							<div data-testid="prevLanguageCode" className={["col-sm-5 col-form-label-value"].join(" ")}>
								{input.languageCode}
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="name" className={["col-sm-2 col-form-label"].join(" ")} >Language</label>
							<div data-testid="prevLanguage" className={["col-sm-5 col-form-label-value"].join(" ")}>
								{input.name}
							</div>
						</div>
						<Row className="lang-preview-buttons">
							<Col lg="2">
								<DABButton id="back" value="BACK" onClick={(e) => { handleBackClick(e); }}></DABButton>
							</Col>
							<Col lg="2" data-testid="createButtonContainer">
								<DABButton value="CREATE" id="create" className="btn-submit-frm" onClick={(e) => { handleNextClick(e); }}></DABButton>
							</Col>
						</Row>
					</div>
				)}

				{isDetailLoaded && (
					<form name="createformEdit" onSubmit={handleSubmit}>
						<DABBackToList onClick={(e) => { handleBackClick(e); }} />
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="languageCode" className={["col-sm-2 col-form-label"].join(" ")}>Code</label>
							<div className={["col-sm-5"].join(" ")}>
								<input disabled={true} maxLength={2} className={["form-control"].join(" ")} id="languageCode" name="languageCode"
									value={input.languageCode} />
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="name" className={["col-sm-2 col-form-label"].join(" ")}>Language</label>
							<div data-testid="nameContainer" className={["col-sm-5"].join(" ")}>
								<DABTextBox id="name" isRequired={true} maxLength={50} onChange={(event) => { handleInputChange(event) }} value={input.name} isHover={true} />
							</div>
						</div>

						<Row className="lang-update-button">
							<Col data-testid="saveChangesButtonContainer" lg="11" className={["pull-right"].join(" ")}>
								<DABButton id="submit" value="SAVE CHANGES" className="btn-submit-frm"></DABButton>
							</Col>
						</Row>
					</form>
				)}
				<Row>
					<Col lg="12" style={{ paddingTop: '20px' }}>
						{formSubmit && languageData.isSuccess && languageData.isError && (
							<div className="alert alert-dismissible alert-danger">
								{languageData.status}
							</div>
						)}
					</Col>
				</Row>
			</div>
		</div>
	);
};

const mapStateToProps = (state: any) => {
	const { languageData } = state;
	return {
		languageData
	};
};

export default connect(mapStateToProps)(LanguageDetail);